const colorFromVehicle = (vehicleKind) => {
  switch (vehicleKind) {
    case 'train':
    case 'subway':
    case 'cartrain':
    case 'nighttrain':
    case 'tram':
    case 'cablecar':
      return 'purple'

    case 'bus':
    case 'busferry':
    case 'nightbus':
      return 'orange'

    case 'shuttle':
    case 'rideshare':
      return 'red'

    case 'plane':
    case 'flight':
    case 'helicopter':
      return 'turquoise'

    case 'ferry':
    case 'carferry':
      return 'blue-light'

    case 'taxi':
      return 'yellow'

    case 'walk':
    case 'foot':
    case 'transfer':
    case 'animal':
    case 'towncar':
      return 'black'

    case 'bicycle':
    case 'cycle':
      return 'green'

    case 'car':
    case 'unknown':
    case 'none':
      return 'grey'

    default:
      throw new Error(`Unrecognised vehicleKind ${vehicleKind}`)
  }
}

const iconFromVehicle = (vehicleKind) => {
  switch (vehicleKind) {
    case 'train':
    case 'subway':
    case 'cartrain':
    case 'nighttrain':
      return 'train'

    case 'tram':
      return 'tram'

    case 'cablecar':
      return 'cablecar'

    case 'bus':
    case 'busferry':
    case 'nightbus':
    case 'rideshare':
    case 'shuttle':
      return 'bus'

    case 'plane':
    case 'flight':
      return 'plane'

    case 'helicopter':
      return 'helicopter'

    case 'ferry':
    case 'carferry':
      return 'ferry'

    case 'car':
    case 'towncar':
      return 'car'

    case 'taxi':
      return 'taxi'

    case 'transfer':
    case 'walk':
    case 'foot':
      return 'walk'

    case 'animal':
      return 'animal'

    case 'bicycle':
    case 'cycle':
      return 'bike'

    case 'unknown':
    case 'none':
      return 'question-mark'

    default:
      throw new Error(`Unrecognised vehicleKind ${vehicleKind}`)
  }
}

export {
  colorFromVehicle,
  iconFromVehicle,
}
